import { escapeRegExp } from "lodash";
import { useMemo } from "react";
import { MonitorRecord } from "./models";

export function useCustomersList(records: MonitorRecord[], searchValue: string) {

  const customersList = useMemo(() => {
    let list = [...records];
    if (!records) return [];

      if (searchValue) {
      const pattern = new RegExp(escapeRegExp(searchValue), "i");

      list = list.filter(customer =>
        pattern.test(customer.bandName as string) || pattern.test(customer.fullName as string)
      );
    }

    return list;
  }, [searchValue, records]);

  return customersList;
}